<!-- LISTING VIEW -->
<div class="profile-container" *ngIf="view === 'list'">
    <div class="profile-content">
        <div class="personal-details">

            <div class="header-block">
                <div class="header-title">
                    <app-breadcrumb></app-breadcrumb>
                </div>
                <div class="add-block">
                    <div class="search" style="margin-right: 15px;">
                        <form autocomplete="off">
                            <input type="text" placeholder="Search" (keyup)="applyFilter($event)">
                        </form>
                        <i class="bi bi-search"></i>
                    </div>
                    <button title="Create Template" (click)="openCreate()"><i class="bi bi-plus-lg"></i>
                        Create Template</button>
                    <div class="filter-icon">
                        <i class="bi bi-arrow-clockwise" title="Refresh"></i>
                    </div>
                </div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 25%;">Name</th>
                        <th style="width: 15%;">Category</th>
                        <th style="width: 10%;">Language</th>
                        <th style="width: 10%;">Clicks</th>
                        <th style="width: 15%;">Status</th>
                        <th style="width: 15%;">Code (JSON)</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                    </tr>
                </thead>
            </table>
            
            <div>
                <div class="data-view" *ngFor="let row of dataSource.filteredData | slice: first : (first + tableSize); let i = index">
                    <p style="width: 25%;"><strong>{{row.name}}</strong> <i class="bi bi-clipboard ml-2 text-muted"></i></p>
                    <p style="width: 15%;">{{row.category | uppercase}}</p>
                    <p style="width: 10%;">
                        <span class="badge badge-light text-success border"><i class="bi bi-globe"></i> {{row.language}}</span>
                    </p>
                    <p style="width: 10%;">{{row.clicks}}</p>
                    <p style="width: 15%;">
                        <span class="status-chip" [ngClass]="getStatusClass(row.status)">
                            <i class="bi bi-check-circle-fill" *ngIf="row.status === 'Enabled'"></i>
                            <i class="bi bi-clock-fill" *ngIf="row.status === 'In Review'"></i>
                            <i class="bi bi-x-circle-fill" *ngIf="row.status === 'Rejected'"></i>
                            <i class="bi bi-slash-circle-fill" *ngIf="row.status === 'Disabled'"></i>
                            {{ row.status }}
                        </span>
                    </p>
                    <p style="width: 15%;">
                        <button class="btn btn-sm btn-link text-secondary"><i class="bi bi-code-slash"></i></button>
                    </p>

                    <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <i title="View" class="bi bi-eye-fill" (click)="openCreate()"></i>
                        <i title="Delete" class="bi bi-trash"></i>
                    </p>
                </div>
            </div>

            <div class="loader" *ngIf="dataSource.filteredData.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
            </div>

            <div class="paginator">
                <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                    [totalRecords]="dataSource.filteredData.length" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                    currentPageReportTemplate="{first} - {last} of {totalRecords}">
                </p-paginator>
            </div>
        </div>
    </div>
</div>

<!-- CREATE VIEW -->
<div class="profile-container" *ngIf="view === 'create'" [formGroup]="templateForm">
    <div class="profile-content">
        <div class="personal-details">
            
            <div class="header-block">
                <div class="header-title">
                    <h5 style="margin: 0; font-weight: 600; color: #24233d;">Create Template</h5>
                </div>
                <div class="add-block d-flex align-items-center">
                    <button class="btn btn-secondary mr-2" (click)="closeCreate()">
                        <i class="bi bi-x-lg"></i> Cancel
                    </button>
                    <button class="btn btn-primary" (click)="onSave()">
                        <i class="bi bi-save"></i> Save
                    </button>
                </div>
            </div>

            <div class="split-layout mt-3">
                
                <!-- LEFT PANEL: FORM -->
                <div class="left-panel shadow-sm">
                    
                  <div class="form-row main-config">
                    <!-- Basic Info Sidebar (Name, Category, Language) -->
                    <div class="basic-info-sidebar" style="padding-right: 20px; border-right: 1px solid #e0e0e0; min-height: 500px;">
                        
                        <!-- Name Field -->
                        <div class="custom-sidebar-group" style="margin-top: 12px; margin-bottom: 24px;">
                            <label for="templateName">Name <span style="color: #ef4444;">*</span></label>
                            <input type="text" formControlName="name" id="templateName" class="custom-text-input">
                        </div>

                        <!-- Category Field -->
                        <div class="custom-sidebar-group" style="margin-bottom: 24px;">
                            <label>Category</label>
                            <select formControlName="category" class="custom-select-box">
                                <option *ngFor="let cat of categories" [value]="cat">{{cat}}</option>
                            </select>
                        </div>

                        <!-- Language Field -->
                        <div class="custom-sidebar-group" style="margin-bottom: 24px;">
                            <label>Language</label>
                            <select formControlName="language" class="custom-select-box">
                                <option *ngFor="let lang of languages" [value]="lang">{{lang}}</option>
                            </select>
                        </div>

                    </div>

                    <!-- Editor Area -->
                    <div class="editor-area">
                        
                        <!-- Type Selector -->
                        <div class="type-selector">
                            <div class="marketing-desc">
                                <strong style="font-size: 16px; color: #374151;">Marketing</strong><br>
                                <small style="color: #6b7280; font-size: 13px;">Send promotions or information about your products, services or business.</small>
                            </div>
                            <div class="custom-toggle-group">
                                <label class="custom-toggle-btn">
                                    <input type="radio" name="templateType" formControlName="templateType" value="Custom">
                                    <span class="toggle-content" [class.active-toggle]="templateForm.value.templateType === 'Custom'">Custom <i class="bi bi-info-circle-fill"></i></span>
                                </label>
                                <label class="custom-toggle-btn">
                                    <input type="radio" name="templateType" formControlName="templateType" value="Product">
                                    <span class="toggle-content" [class.active-toggle]="templateForm.value.templateType === 'Product'">Product <i class="bi bi-info-circle-fill"></i></span>
                                </label>
                                <label class="custom-toggle-btn">
                                    <input type="radio" name="templateType" formControlName="templateType" value="Carousel">
                                    <span class="toggle-content" [class.active-toggle]="templateForm.value.templateType === 'Carousel'">Carousel <i class="bi bi-info-circle-fill"></i></span>
                                </label>
                            </div>
                        </div>

                        <!-- Header -->
                        <div class="section-block">
                            <label class="section-label">Header <span class="optional">(Optional)</span></label>
                            <small class="section-hint">Add a title or choose which type of media you'll use for this header.</small>
                            <div class="header-inputs">
                                <div class="custom-form-group">
                                    <label>&nbsp;</label>
                                    <select class="custom-select-box">
                                        <option value="Media">Media</option>
                                        <option value="Text">Text</option>
                                    </select>
                                </div>
                                <div class="custom-form-group" *ngIf="templateForm.value.templateType !== 'Carousel'">
                                    <label>Media Type *</label>
                                    <select formControlName="headerType" class="custom-select-box">
                                        <option *ngFor="let t of headerTypes" [value]="t">{{t}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <!-- Body (For Custom / Product) -->
                        <div class="section-block" *ngIf="templateForm.value.templateType !== 'Carousel'">
                            <label class="section-label">Body</label>
                            <small class="section-hint">Enter the text for your message in the language that you've selected.</small>
                            
                            <div class="body-editor-wrapper">
                                <textarea #mainBodyInput matInput formControlName="bodyText" class="body-textarea" rows="8"></textarea>
                                <div class="editor-toolbar">
                                    <div class="toolbar-actions">
                                        <button type="button" mat-icon-button (click)="applyFormat('emoji', mainBodyInput, templateForm.get('bodyText'))"><mat-icon>sentiment_satisfied_alt</mat-icon></button>
                                        <button type="button" mat-icon-button (click)="applyFormat('bold', mainBodyInput, templateForm.get('bodyText'))"><strong>B</strong></button>
                                        <button type="button" mat-icon-button (click)="applyFormat('italic', mainBodyInput, templateForm.get('bodyText'))"><em>I</em></button>
                                        <button type="button" mat-icon-button (click)="applyFormat('strikethrough', mainBodyInput, templateForm.get('bodyText'))"><span style="text-decoration: line-through;">S</span></button>
                                    </div>
                                    <button type="button" mat-button color="primary" (click)="addVariable()">+ Add Variable</button>
                                </div>
                            </div>
                        </div>

                        <!-- Carousel Settings -->
                        <div class="section-block" *ngIf="templateForm.value.templateType === 'Carousel'">
                            <label class="section-label">Carousel</label>
                            <small class="section-hint">In a carousel the Header type and buttons type will be same for all the cards.</small>
                            
                            <div class="carousel-global-settings" style="display: flex; gap: 16px; margin-bottom: 24px;">
                                <div class="custom-form-group">
                                    <label>Header Type</label>
                                    <select class="custom-select-box">
                                        <option value="Image">Image</option>
                                        <option value="Video">Video</option>
                                    </select>
                                </div>
                                <div class="custom-form-group">
                                    <label>Button 1 Type</label>
                                    <select class="custom-select-box">
                                        <option value="Custom">Custom</option>
                                    </select>
                                </div>
                                <div class="custom-form-group">
                                    <label>Button 2 Type</label>
                                    <select class="custom-select-box">
                                        <option value="None">None</option>
                                        <option value="Custom">Custom</option>
                                    </select>
                                </div>
                            </div>

                            <div class="cards-list" formArrayName="cards">
                                <button type="button" mat-button color="primary" style="margin-bottom: 16px;" (click)="addCard()">+ Add Card</button>
                                <div *ngFor="let card of cards.controls; let i=index" [formGroupName]="i" class="card-item" style="background: #f8f9fa; padding: 16px; border-radius: 8px; border: 1px solid #e0e0e0; margin-bottom: 16px;">
                                    <h4 style="margin-top: 0; display: flex; justify-content: space-between; align-items: center;">
                                        Card {{i + 1}}
                                        <button type="button" mat-icon-button color="warn" (click)="removeCard(i)" *ngIf="cards.length > 1"><mat-icon>delete</mat-icon></button>
                                    </h4>
                                    <label class="section-label">Body</label>
                                    <small class="section-hint">Enter the text for your message in the language that you've selected.</small>
                                    <div class="body-editor-wrapper">
                                        <textarea #cardBodyInput matInput formControlName="body" class="body-textarea" rows="4" style="border: 1px solid #dadce0; border-radius: 4px; padding: 12px; width: 100%; border-bottom-left-radius: 0; border-bottom-right-radius: 0;"></textarea>
                                        <div class="editor-toolbar" style="border: 1px solid #dadce0; border-top: none; border-bottom-left-radius: 4px; border-bottom-right-radius: 4px; margin-top: -5px; padding: 4px 8px;">
                                            <div class="toolbar-actions">
                                                <button type="button" mat-icon-button (click)="applyFormat('emoji', cardBodyInput, card.get('body'))"><mat-icon>sentiment_satisfied_alt</mat-icon></button>
                                                <button type="button" mat-icon-button (click)="applyFormat('bold', cardBodyInput, card.get('body'))"><strong>B</strong></button>
                                                <button type="button" mat-icon-button (click)="applyFormat('italic', cardBodyInput, card.get('body'))"><em>I</em></button>
                                                <button type="button" mat-icon-button (click)="applyFormat('strikethrough', cardBodyInput, card.get('body'))"><span style="text-decoration: line-through;">S</span></button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Footer (For Custom / Product) -->
                        <div class="section-block" *ngIf="templateForm.value.templateType !== 'Carousel'">
                            <label class="section-label">Footer <span class="optional">(Optional)</span></label>
                            <small class="section-hint">Add a short line of text to the bottom of your message template.</small>
                            <div style="margin-top: 12px;">
                                <input type="text" formControlName="footerText" class="custom-text-input" placeholder="Enter text..." style="width: 100%;">
                            </div>
                        </div>

                        <!-- Buttons (For Custom / Product) -->
                        <div class="section-block buttons-block" *ngIf="templateForm.value.templateType !== 'Carousel'">
                            <button mat-raised-button color="primary" [matMenuTriggerFor]="btnMenu" class="add-btn-btn" *ngIf="buttons.length < 3">
                                + Add Button
                            </button>
                            <mat-menu #btnMenu="matMenu" class="button-menu">
                                <div class="menu-header">Quick Reply Button</div>
                                <button mat-menu-item (click)="addButton('Quick Reply')">Custom</button>
                                <div class="menu-header mt-2">Call-To-Action Buttons</div>
                                <button mat-menu-item (click)="addButton('Call Phone Number')">
                                    Call Phone Number <br><small>1 button maximum</small>
                                </button>
                                <button mat-menu-item (click)="addButton('Copy Offer Code')">
                                    Copy Offer Code <br><small>1 button maximum</small>
                                </button>
                                <button mat-menu-item (click)="addButton('Visit Website')">
                                    Visit Website <br><small>2 buttons maximum</small>
                                </button>
                            </mat-menu>

                            <div formArrayName="buttons" class="buttons-list">
                                <div *ngFor="let btn of buttons.controls; let i=index" [formGroupName]="i" class="button-item">
                                    <mat-form-field appearance="outline" class="btn-type">
                                        <input matInput [value]="btn.value.type" readonly>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="btn-text">
                                        <input matInput formControlName="text" placeholder="Button Text">
                                    </mat-form-field>
                                    <button mat-icon-button color="warn" (click)="removeButton(i)"><mat-icon>delete</mat-icon></button>
                                </div>
                            </div>
                        </div>

                    </div>
                  </div>

                </div>

                <!-- RIGHT PANEL: PREVIEW -->
                <div class="right-panel shadow-sm">
                    <h3 class="preview-title">Preview</h3>
                    <div class="whatsapp-preview-box">
                        <div class="wa-message-bubble">
                            
                            <!-- Media Placeholder -->
                            <div class="wa-media-placeholder" *ngIf="templateForm.value.headerType === 'Image'">
                                <mat-icon>image</mat-icon>
                            </div>

                            <!-- Text Body (Custom/Product) -->
                            <div class="wa-body" *ngIf="templateForm.value.templateType !== 'Carousel'">
                                {{templateForm.value.bodyText}}
                            </div>

                            <!-- Footer Preview -->
                            <div class="wa-footer" *ngIf="templateForm.value.templateType !== 'Carousel' && templateForm.value.footerText" style="font-size: 12.5px; color: #667781; padding: 0 12px 10px 12px; margin-top: -6px;">
                                {{templateForm.value.footerText}}
                            </div>

                            <!-- Carousel Cards Preview -->
                            <div class="wa-carousel-preview" *ngIf="templateForm.value.templateType === 'Carousel'" style="display: flex; gap: 8px; overflow-x: auto; padding: 12px; background: #e9edef;">
                                <div *ngFor="let card of cards.controls; let i=index" style="flex: 0 0 200px; background: white; border-radius: 8px; padding: 12px; box-shadow: 0 1px 2px rgba(0,0,0,0.1);">
                                    <div class="wa-media-placeholder" style="height: 100px; margin-bottom: 8px; border-radius: 4px;">
                                        <mat-icon>image</mat-icon>
                                    </div>
                                    <div class="wa-body" style="padding: 0; font-size: 13px;">
                                        {{card.value.body}}
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Buttons -->
                            <div class="wa-buttons" *ngIf="buttons.length > 0">
                                <div class="wa-btn" *ngFor="let btn of buttons.controls">
                                    <mat-icon *ngIf="btn.value.type === 'Visit Website'">open_in_new</mat-icon>
                                    <mat-icon *ngIf="btn.value.type === 'Call Phone Number'">call</mat-icon>
                                    <mat-icon *ngIf="btn.value.type === 'Copy Offer Code'">content_copy</mat-icon>
                                    <mat-icon *ngIf="btn.value.type === 'Quick Reply'">reply</mat-icon>
                                    {{ btn.value.text || btn.value.type }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
